import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ITInfrastructureContent() {
  useEffect(() => {
    document.title = "Tita Technologies | IT Solutions";
  }, []);

  const sections = [
    {
      title: "IT Infrastructure & Hardware Solutions",
      description:
        "Enterprise Computing Devices, Data Center Solutions, Network & Security Equipment, Smart Security, Audio-Visual Solutions, and more.",
      image: "assets/img/IT Infrastructure & Hardware Solutions.jpg",
    },
    {
      title: "Global Managed IT Services",
      description:
        "24/7 Remote & On-Site Support, IT Asset Lifecycle Management, Server & Network Monitoring, Global IT Vendor Management.",
      image: "assets/img/Global Managed IT Services.jpg",
    },
    {
      title: "Cloud Computing & Hybrid Cloud Solutions",
      description:
        "Cloud Strategy & Migration, Cloud Security, Disaster Recovery, Hybrid & Multi-Cloud Deployments.",
      image: "assets/img/Cloud Computing & Hybrid Cloud Solutions.jpg",
    },
    {
      title: "Cybersecurity & Compliance Solutions",
      description:
        "International Security Standards, Threat Intelligence, Incident Response, Data Privacy Solutions.",
      image: "assets/img/Cybersecurity & Compliance Solutions.jpg",
    },
    {
      title: "IT Consulting & Digital Transformation",
      description:
        "Global IT Strategy, Enterprise Software Solutions, IT Integration for MNCs, Vendor & SLA Management.",
      image: "assets/img/IT Consulting & Digital Transformation.jpg",
    },
    {
      title: "Smart Building & IoT Solutions",
      description:
        "AI-Enabled Security Systems, Building Management Systems, IoT-Driven Smart Infrastructure.",
      image: "assets/img/Smart Building & IoT Solutions.jpg",
    },
    {
      title: "Global Data Protection & Backup Solutions",
      description:
        "Cloud & On-Premise Data Backup, Business Continuity Planning, High Availability Solutions.",
      image: "assets/img/Global Data Protection & Backup Solutions.jpg",
    },
  ];

  const fadeInVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#FFF5F7", padding: "24px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "32px",
            color: "#FF001E",
          }}
        >
          Tita Technologies – Global IT Infrastructure & Solutions Provider
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
          style={{ textAlign: "center", color: "#7C0A1E", marginBottom: "40px" }}
        >
          With 25+ years of industry expertise, Tita Technologies delivers cutting-edge IT solutions to businesses worldwide.
        </motion.p>

        {sections.map((section, index) => (
          <motion.div
            key={index}
            variants={fadeInVariant}
            initial="hidden"
            animate="visible"
            style={{
              display: "flex",
              flexDirection: index % 2 === 0 ? "row" : "row-reverse",
              alignItems: "center",
              gap: "24px",
              marginBottom: "48px",
              backgroundColor: "#FFFFFF",
              padding: "16px",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <motion.img
              src={section.image}
              alt={section.title}
              style={{ width: "50%", borderRadius: "8px" }}
              whileHover={{ scale: 1.05 }}
            />
            <div>
              <h2 style={{ fontSize: "24px", fontWeight: "600", color: "#7C0A1E", marginBottom: "16px" }}>
                {section.title}
              </h2>
              <p style={{ color: "#7C0A1E" }}>{section.description}</p>
            </div>
          </motion.div>
        ))}

        <div style={{ textAlign: "center", marginTop: "64px" }}>
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            style={{ fontSize: "24px", fontWeight: "bold", color: "#FF001E", marginBottom: "16px" }}
          >
            Empowering Businesses Worldwide with Future-Ready IT Solutions!
          </motion.h3>

          <Link to="/contact">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              style={{
                padding: "12px 24px",
                backgroundColor: "#FF001E",
                color: "#FFFFFF",
                borderRadius: "8px",
                fontSize: "16px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Contact Us
            </motion.button>
          </Link>
        </div>
      </div>
    </div>
  );
}
